export function clearUserLocalStorage(): void {
  if (typeof window === 'undefined') return
  try {
    const keys = Object.keys(window.localStorage)
    keys.forEach((key) => {
      if (key.startsWith('nectar:')) {
        window.localStorage.removeItem(key)
      }
    })
  } catch (err) {
    console.warn('clearUserLocalStorage failed', err)
  }
}
